import ManageTemplateContainer from './ManageTemplateContainer'

export default ManageTemplateContainer
